import { mode } from "@chakra-ui/theme-tools";
export const globalStyles = {
  colors: {
    // Al Ameen News brand gold, anchored on the logo's #C7B45E.
    // Rule: never use brand.500 as text on white (fails contrast) — use
    // brand.600/700 for text, brand.500 for backgrounds/borders, and dark
    // text (#1A1A1A) on brand.500 backgrounds.
    brand: {
      50: "#FBF8EE",
      100: "#F3EDD6",
      200: "#E7DEB5",
      300: "#DCCF94",
      400: "#D2C077",
      500: "#C7B45E",
      600: "#8F7A2E",
      700: "#6E5D20",
      800: "#4D4012",
      900: "#2C2304",
    },
    brandScheme: {
      50: "#FBF8EE",
      100: "#F3EDD6",
      200: "#E7DEB5",
      300: "#DCCF94",
      400: "#D2C077",
      500: "#C7B45E",
      600: "#8F7A2E",
      700: "#6E5D20",
      800: "#4D4012",
      900: "#2C2304",
    },
    brandTabs: {
      50: "#FBF8EE",
      100: "#F3EDD6",
      200: "#DCCF94",
      300: "#DCCF94",
      400: "#C7B45E",
      500: "#C7B45E",
      600: "#8F7A2E",
      700: "#6E5D20",
      800: "#4D4012",
      900: "#2C2304",
    },
    secondaryGray: {
      100: "#E0E5F2",
      200: "#E1E9F8",
      300: "#F4F7FE",
      400: "#E9EDF7",
      500: "#8F9BBA",
      600: "#A3AED0",
      700: "#707EAE",
      800: "#707EAE",
      900: "#1B2559",
    },
    red: {
      100: "#FEEFEE",
      500: "#EE5D50",
      600: "#E31A1A",
    },
    cyan: {
      50: "#EFF4FB",
      500: "#3965FF",
    },
    orange: {
      100: "#FFF6DA",
      500: "#FFB547",
    },
    green: {
      100: "#E6FAF5",
      500: "#01B574",
    },
    navy: {
      50: "#d0dcfb",
      100: "#aac0fe",
      200: "#a3b9f8",
      300: "#728fea",
      400: "#3652ba",
      500: "#1b3bbb",
      600: "#24388a",
      700: "#1B254B",
      800: "#111c44",
      900: "#0b1437",
    },
    gray: {
      100: "#FAFCFE",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        overflowX: "hidden",
        bg: mode("secondaryGray.300", "navy.900")(props),
        fontFamily: "DM Sans",
        letterSpacing: "-0.5px",
      },
      input: {
        color: "gray.700",
      },
      html: {
        fontFamily: "DM Sans",
      },
    }),
  },
};
